import { CircleAlert } from 'lucide-react';
import { Link } from 'react-router';

import { EmptyState } from '../components/EmptyState';

export function NotFoundPage() {
  return (
    <EmptyState
      icon={CircleAlert}
      title="Página não encontrada"
      description="O endereço acessado não existe ou foi movido."
      action={
        <Link
          to="/live"
          className="inline-flex h-8 items-center rounded-md border border-line-strong bg-surface-raised px-3 text-[13px] font-medium text-fg hover:bg-surface-hover"
        >
          Ir para Ao vivo
        </Link>
      }
    />
  );
}
